import OktaAuth from "@okta/okta-auth-js";

const CLIENT_ID = process.env.OKTA_CLIENT_ID;
const ISSUER = process.env.OKTA_ISSUER;
const REDIRECT_URI = process.env.OKTA_REDIRECT_URI;

const oktaAuth = new OktaAuth({
  clientId: CLIENT_ID,
  issuer: ISSUER,
  redirectUri: REDIRECT_URI,
  scopes: ["openid", "profile", "email", "groups", "offline_access"],
  pkce: true,
  tokenManager: {
    storage: "localStorage",
    autoRenew: true,
    autoRemove: true
  },
  services: {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
    renewOnTabActivation: true
  }
});

export { oktaAuth };
